import { createApp, h } from "vue";
import { createInertiaApp, Link, Head } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import Layout from "./Shared/Layout";

import VueSocialSharing from 'vue-social-sharing'

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faCartShopping, faBars, faBowlHot, faClockThree, faMagnifyingGlass, faXmark, faAngleRight, faPlus, faMinus } from '@fortawesome/pro-regular-svg-icons';
import { faMicrophone, faClapperboardPlay, faUser, faArrowTurnDownLeft, faHeart } from '@fortawesome/pro-solid-svg-icons';
import { faYoutube, faFacebookF, faInstagram, faWhatsapp, faPinterest } from '@fortawesome/free-brands-svg-icons';
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons';



library.add(faCartShopping,
    faBars,
    faBowlHot,
    faMicrophone,
    faYoutube,
    faClockThree,
    faClapperboardPlay,
    faMagnifyingGlass,
    faFacebookF,
    faInstagram,
    faWhatsapp,
    faPinterest,
    faXmark,
    faAngleRight,
    faUser,
    faPlus,
    faMinus,
    faArrowTurnDownLeft,
    faThumbsUp,
    faHeart
);

createInertiaApp({
    resolve: name => {
        let page = require(`./Pages/${name}`).default;

        if (page.layout === undefined) {
            page.layout = Layout;
        }

        return page;
    },

    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .component("Link", Link)
            .component("Head", Head)
            .component('font-awesome-icon', FontAwesomeIcon)
            .use(VueSocialSharing)
            .mount(el);
    },

    title: title => `Chokis® - ${title}`
});

InertiaProgress.init({
    color: '#05017e'
})


